import useConfirmationSubmit from '../hooks/useConfirmationSubmit';
import '../CSS/pages.css';

function OwnerOperator() {
  const { handleSubmit, isSubmitting, submitError } = useConfirmationSubmit(
    'ownerOperator',
    'owner operator support'
  );

  return (
    <main className="page service-page">
      <section className="page-heading">
        <p className="eyebrow">Owner operator</p>
        <h1>Dispatch support for single-truck operators.</h1>
        <p>
          Emmapro Logistixs helps owner operators find freight opportunities,
          coordinate broker details, and plan routes with clear communication
          from pickup through delivery.
        </p>
      </section>

      <section className="contact-layout">
        <form className="contact-form" onSubmit={handleSubmit}>
          <label>
            Name
            <input type="text" name="name" placeholder="Your name" required />
          </label>
          <label>
            Email
            <input
              type="email"
              name="email"
              placeholder="you@example.com"
              autoComplete="email"
              required
            />
          </label>
          <label>
            Phone number
            <input type="tel" name="phone" placeholder="(555) 000-0000" required />
          </label>
          <label>
            Equipment type
            <select name="equipmentType" defaultValue="" required>
              <option value="" disabled>
                Select equipment type
              </option>
              <option value="dry-van">Dry van</option>
              <option value="reefer">Reefer</option>
              <option value="flatbed">Flatbed</option>
              <option value="step-deck">Step deck</option>
              <option value="box-truck">Box truck</option>
              <option value="power-only">Power only</option>
              <option value="hotshot">Hotshot</option>
            </select>
          </label>
          <label>
            Message
            <textarea
              name="message"
              rows="5"
              placeholder="Tell us about your lanes, schedule, goals, or dispatch needs"
              required
            />
          </label>
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Sending...' : 'Request owner operator support'}
          </button>
          {submitError && <p className="form-error">{submitError}</p>}
        </form>

        <aside className="contact-panel">
          <h2>What this service covers</h2>
          <p>
            Practical dispatch help focused on keeping your truck moving with
            freight that fits your equipment, schedule, and preferred lanes.
          </p>
          <ul>
            <li>Load opportunity review</li>
            <li>Broker and rate confirmation coordination</li>
            <li>Pickup and delivery detail tracking</li>
            <li>Route and backhaul planning support</li>
          </ul>
        </aside>
      </section>
    </main>
  );
}

export default OwnerOperator;
